import { BaseParameterDto } from './base-parameter-dto';

export class BaseResidentParameterDto extends BaseParameterDto {
  customerId: string; //16 character starts with "R"
  communityId: number; //Account #

  constructor(customerId?: string, communityId?: number) {
    super();
    this.customerId = customerId;
    this.communityId = communityId;
  }

  override getQueryString(): string {
    return `?customerId=${this.customerId}&communityId=${this.communityId}&clearCache=${this.clearCache}`;
  }
}
